import { Component } from "@angular/core";

import { Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { DataService } from "./services/data.service";
import { LoadingService } from "./services/loading.service";
import { LoginService } from "./services/login.service";
import { LocalStorageService } from "./services/local-storage.service";
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { AngularFireDatabase } from "@angular/fire/database";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"]
})
export class AppComponent {
  user: any;
  acceptedTAndC = false;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private afAuth: AngularFireAuth,
    private dataProvider: DataService,
    private loadingProvider: LoadingService,
    private loginService: LoginService,
    private localStorage: LocalStorageService,
    private afdb: AngularFireDatabase,
    private fcm: FirebaseX
  ) {
    // const firestore = afs.firestore.settings({ timestampsInSnapshots: true });
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      let isPushEnabled =
        localStorage.getItem("isPushEnabled") == "true" ? true : false;

      this.statusBar.styleDefault();
      //this.router.navigateByUrl("/login");

      this.platform.backButton.subscribe(() => null);

      this.fcm.setBadgeNumber(0);

      this.afAuth.auth.onAuthStateChanged(user => {
        if (user == null) {
          this.router.navigateByUrl("/login");
          this.splashScreen.hide();
        } else {
          this.dataProvider
            .getCurrentUser()
            .snapshotChanges()
            .subscribe(user => {
              this.user = user.payload.val();
              if (this.acceptedTAndC === false) {
              }
              if (this.user && this.user.enabled && this.user.enabled == true) {
                try {
                  let isOnDesktop = this.platform.is('desktop');
                  if (isPushEnabled == false && !isOnDesktop ) {
                    // Registering for push notification
                    this.fcm.hasPermission().then(hasPermission => {
                      if (!hasPermission) {
                        this.fcm.grantPermission().then(data => {});
                      } else {
                        this.fcm
                          .getToken()
                          .then(token => {
                            // console.log(token);
                            this.afdb
                              .object(
                                "/accounts/" + this.afAuth.auth.currentUser.uid
                              )
                              .update({ pushToken: token });
                            localStorage.setItem("isPushEnabled", "true");
                          })
                          .catch(err => {
                            // console.log(err);
                          });
                        this.fcm.onTokenRefresh().subscribe(token => {
                          // console.log(token);
                          this.afdb
                            .object(
                              "/accounts/" + this.afAuth.auth.currentUser.uid
                            )
                            .update({ pushToken: token });
                        });
                      }
                    });
                  }
                  // this.fcm.onMessageReceived().subscribe(data => {
                  //   // console.log(data);
                  // });

                  if (this.router.url === "/" || this.router.url === "/login") {
                    this.localStorage.getAcceptedTerms().then(val => {
                      val === true
                        ? this.router.navigate(["/tabs"])
                        : this.router.navigate(["/walkthrough"]);
                    });
                  }
                } catch (err) {
                  console.log("This is normal in a browser", err);
                }

                // if (this.router.url === "/" || this.router.url === "/login") {
                //   this.router.navigateByUrl("/walkthrough");
                // }
                this.splashScreen.hide();
              } else {
                this.loadingProvider.showToast(
                  "Your account is awaiting approval"
                );
                this.splashScreen.hide();

                this.loginService.logout();
                this.router.navigateByUrl("/login");
              }
            });
        }
      });
    });
  }
}
